import { upsertCommendaOSEntity } from '@commenda/api/commenda-os-dsl';
import type { DSLContext } from '@commenda/types/src/commenda-os-dsl';

/**
 * Writes the number a `resolveBy` GovernmentIdentifier collected. The standard submit writes only
 * identifiers a form names outright; which one this is, only the entity can say.
 */
export async function saveResolvedGovernmentIdentifier({
  identifierTypeId,
  value,
  heldValue,
  context,
  shareToken,
}: {
  identifierTypeId: string;
  value: string;
  /** What the entity already records, so an untouched answer writes nothing. */
  heldValue: string | undefined;
  context: DSLContext;
  shareToken: string | undefined;
}): Promise<void> {
  if (!value || value === heldValue) return;

  const { result } = await upsertCommendaOSEntity(
    'governmentIdentifier',
    [{ key: 'identifierTypeId', value: identifierTypeId }],
    [{ path: 'value', value }],
    context,
    shareToken
  );
  if (!result.success) {
    throw new Error(result.error ?? `Could not save ${identifierTypeId}`);
  }
}
